import { useEffect, useState } from "react";
import styled from "styled-components";

const Bar = styled.div`
  position: fixed;
  left: 18px;
  right: 18px;
  bottom: 18px;
  z-index: 99999;

  background: #1e1e1e;
  color: #ffffff;
  border: 1px solid rgba(252, 154, 196, 0.28);
  border-radius: 24px;
  padding: 18px 20px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 18px;

  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.35);

  @media (max-width: 768px) {
    border-radius: 20px;
    flex-direction: column;
    align-items: flex-start;
    left: 12px;
    right: 12px;
    bottom: 4px;
    padding: 16px;
  }
`;

const Text = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.86);

  a {
    color: #fc9ac4;
    font-weight: 700;
    text-decoration: none;
    margin-left: 4px;
  }
`;

const Actions = styled.div`
  display: flex;
  gap: 10px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Btn = styled.button`
  border: none;
  cursor: pointer;
  border-radius: 999px;
  padding: 11px 18px;
  font-size: 13px;
  font-weight: 800;
  transition: 0.2s ease;

  ${({ $primary }) =>
    $primary
      ? `
      background: #fc9ac4;
      color: #1e1e1e;
    `
      : `
      background: transparent;
      color: #ffffff;
      border: 1px solid rgba(255,255,255,0.25);
    `}

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  @media (max-width: 768px) {
    flex: 1;
  }
`;

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");

    if (!consent) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    window.dispatchEvent(new Event("cookieConsentChanged"));
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem("cookie_consent", "rejected");
    window.dispatchEvent(new Event("cookieConsentChanged"));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Bar>
      <Text>
        Folosim cookie-uri pentru funcționarea site-ului și pentru o experiență
        mai dulce pe Ahava Cakes.
        <a href="/cookies">Află mai multe</a>
      </Text>

      <Actions>
        <Btn onClick={reject}>Respinge</Btn>
        <Btn $primary onClick={accept}>
          Acceptă
        </Btn>
      </Actions>
    </Bar>
  );
}
